export default {"src":"/_next/static/media/talentIcon.40ce08bb.svg","height":48,"width":48};